var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlinetransactionsBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.33,401.52c33-26.47,52-66.64,52.59-108.94.37-26.66-1.54-60.16-10.5-88.82C662.88,109.22,579.41,58,518.35,47S394.41,56.12,347,88s-42.84,26.43-123.95,14.58S75.43,125.39,53.56,189.18s44.65,99.95,51.94,133.36S100,415.2,226.72,429.78s165-56.5,227.84-36.45C505.16,409.46,580.54,457.46,650.33,401.52Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.33,401.52c33-26.47,52-66.64,52.59-108.94.37-26.66-1.54-60.16-10.5-88.82C662.88,109.22,579.41,58,518.35,47S394.41,56.12,347,88s-42.84,26.43-123.95,14.58S75.43,125.39,53.56,189.18s44.65,99.95,51.94,133.36S100,415.2,226.72,429.78s165-56.5,227.84-36.45C505.16,409.46,580.54,457.46,650.33,401.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.51,295.78v-5.67c0-11.18-7.45-15.14-15.05-15.14a14.62,14.62,0,0,0-14.88,15.14v5.67h-2.12v31.38h34V295.78ZM382.46,313v5.68h-3.22V313a4.3,4.3,0,1,1,3.22,0Zm9.34-17.25H371.12v-5.67a10.35,10.35,0,0,1,10.34-10.33c5.7,0,10.34,3.9,10.34,10.33Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.62,
    y: 38.68,
    width: 123.3,
    height: 26.95,
    rx: 13.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.26,50.9l2.8,3.1-1.35,1-2.09-3.69L571.55,55l-1.35-1L573,50.9l-4.11-.85.51-1.62,3.87,1.7-.48-4.19h1.7L574,50.13l3.87-1.67.5,1.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M584.72,50.9l2.81,3.1-1.35,1-2.09-3.69L582,55l-1.35-1,2.78-3.1-4.11-.85.5-1.62,3.87,1.7-.47-4.19h1.69l-.45,4.19,3.87-1.67.51,1.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595.19,50.9,598,54l-1.35,1-2.1-3.69L592.49,55l-1.36-1,2.79-3.1-4.11-.85.5-1.62,3.87,1.7-.47-4.19h1.69L595,50.13l3.87-1.67.51,1.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M605.66,50.9l2.81,3.1-1.35,1L605,51.32,603,55l-1.35-1,2.79-3.1-4.11-.85.5-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M616.13,50.9l2.81,3.1-1.36,1-2.09-3.69L613.42,55l-1.35-1,2.78-3.1-4.11-.85.51-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M626.59,50.9,629.4,54l-1.35,1L626,51.32,623.89,55l-1.35-1,2.78-3.1-4.11-.85.5-1.62,3.87,1.7-.47-4.19h1.69l-.45,4.19,3.87-1.67.51,1.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M637.06,50.9l2.81,3.1-1.35,1-2.1-3.69L634.36,55,633,54l2.79-3.1-4.11-.85.5-1.62,3.87,1.7-.47-4.19h1.69l-.45,4.19,3.87-1.67.51,1.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M647.53,50.9l2.81,3.1L649,55l-2.1-3.69L644.82,55l-1.35-1,2.79-3.1-4.11-.85.5-1.62,3.87,1.7L646,45.94h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.82,127.81A4.82,4.82,0,1,0,34,132.62,4.82,4.82,0,0,0,38.82,127.81Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,127.81a4.82,4.82,0,1,0-4.81,4.81A4.81,4.81,0,0,0,79,127.81Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.28,
    cy: 127.81,
    r: 4.82,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82,158.31A4.82,4.82,0,1,0,34,163.13,4.81,4.81,0,0,0,38.82,158.31Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,158.31a4.82,4.82,0,1,0-4.81,4.82A4.81,4.81,0,0,0,79,158.31Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09,158.31a4.82,4.82,0,1,0-4.81,4.82A4.81,4.81,0,0,0,119.09,158.31Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82,188.82A4.82,4.82,0,1,0,34,193.63,4.82,4.82,0,0,0,38.82,188.82Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,188.82a4.82,4.82,0,1,0-4.81,4.81A4.81,4.81,0,0,0,79,188.82Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09,188.82a4.82,4.82,0,1,0-4.81,4.81A4.81,4.81,0,0,0,119.09,188.82Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 183,
    r: 21.61,
    transform: "translate(68.01 530.19) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.23,196.71v2.09h-3.63v-2.1c-3.14-.65-4.74-3.08-4.72-6.9v-.89l4.19,0v1.17c0,2,.8,2.78,2.21,2.78s2.22-.75,2.22-2.77c0-5.79-8.63-6.11-8.6-14.16,0-3.83,1.68-6.28,4.82-6.91V167h3.62v2.06c3.17.65,4.77,3.12,4.76,6.94v1.93H676.9v-2.22c0-2-.87-2.74-2.28-2.74s-2.3.71-2.31,2.72c0,5.8,8.64,6.12,8.6,14.17C680.91,193.63,679.33,196,676.23,196.71Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 380.35,
    cy: 379.89,
    r: 13.89,
    transform: "translate(-157.22 380.21) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.78,388.69V390h-2.33v-1.35c-2-.42-3-2-3-4.43v-.57h2.69v.75c0,1.29.51,1.79,1.41,1.79s1.43-.49,1.43-1.78c0-3.72-5.54-3.93-5.52-9.1,0-2.46,1.07-4,3.09-4.44v-1.32h2.33v1.32c2,.42,3.07,2,3.06,4.46v1.24h-2.69v-1.42c0-1.29-.56-1.76-1.46-1.76s-1.48.46-1.49,1.75c0,3.72,5.55,3.93,5.53,9.1C384.79,386.71,383.77,388.26,381.78,388.69Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M484.39,60.15a13.89,13.89,0,1,0-13.83-13.94A13.88,13.88,0,0,0,484.39,60.15Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.87,55.07v1.34h-2.33V55.06c-2-.42-3.05-2-3-4.44v-.57h2.69v.75c0,1.3.51,1.79,1.42,1.8s1.42-.49,1.43-1.78c0-3.73-5.55-3.93-5.53-9.11,0-2.45,1.08-4,3.1-4.43V36H486V37.3c2.05.42,3.07,2,3.06,4.46V43h-2.69V41.57c0-1.3-.57-1.76-1.47-1.77s-1.48.46-1.48,1.75c0,3.73,5.54,3.93,5.52,9.11C488.88,53.09,487.87,54.64,485.87,55.07Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 75.43,
    cy: 85.25,
    r: 18.44,
    transform: "translate(-38.19 78.31) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.33,97v1.78H74.23V96.94c-2.68-.56-4-2.63-4-5.9v-.75h3.57v1c0,1.72.68,2.37,1.88,2.38s1.89-.65,1.9-2.37c0-4.94-7.37-5.21-7.34-12.08,0-3.27,1.43-5.36,4.11-5.9V71.58h3.09v1.75c2.72.56,4.08,2.67,4.07,5.93v1.65H77.91V79c0-1.72-.75-2.34-2-2.35s-2,.61-2,2.33c0,5,7.37,5.22,7.34,12.09C81.33,94.32,80,96.37,77.33,97Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698,279.65s-9.87-5.49-10.6,6.94-2.56,115.54-2.56,115.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.27,287.69s8.05,40.23,4.4,113.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.18,282.15s-3.77,2.42-5.92-.35,1.45-7.84-1.72-10-8.66,1.14-8.66,1.14,4.22,1.24,4.09,3.54-2.17,3.18-2.44,2.17-2.29-6.08-5.71-4a8.47,8.47,0,0,0-4,5.38s8-.85,8.46,2.15-3.28-.52-6.57-.71-6.29.28-6.08,2.28a25.51,25.51,0,0,1-.31,5.27,9.81,9.81,0,0,1,6.41-2.27c3.62.21,3.49,2.52.19,2.32s-6.11,3-6.11,3,3,5.13,6.81,7.66,5.19,1.63,5.63-.32-.58-7,1.73-6.84-3.82,8.69-.87,9.2,5.3-.35,6.08-2.29l.77-1.93s-1-5-.58-7,1,.06,1.51,2.4.85,8,1.86,7.71,4.22-4.38,5-6-4.23-6.52-4.18-7.51,3.91.89,4.51,1.92a24.77,24.77,0,0,1,1.18,2.38s2.41-1.51,2.35-6.14S690.18,282.15,690.18,282.15Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.18,282.15s-3.77,2.42-5.92-.35,1.45-7.84-1.72-10-8.66,1.14-8.66,1.14,4.22,1.24,4.09,3.54-2.17,3.18-2.44,2.17-2.29-6.08-5.71-4a8.47,8.47,0,0,0-4,5.38s8-.85,8.46,2.15-3.28-.52-6.57-.71-6.29.28-6.08,2.28a25.51,25.51,0,0,1-.31,5.27,9.81,9.81,0,0,1,6.41-2.27c3.62.21,3.49,2.52.19,2.32s-6.11,3-6.11,3,3,5.13,6.81,7.66,5.19,1.63,5.63-.32-.58-7,1.73-6.84-3.82,8.69-.87,9.2,5.3-.35,6.08-2.29l.77-1.93s-1-5-.58-7,1,.06,1.51,2.4.85,8,1.86,7.71,4.22-4.38,5-6-4.23-6.52-4.18-7.51,3.91.89,4.51,1.92a24.77,24.77,0,0,1,1.18,2.38s2.41-1.51,2.35-6.14S690.18,282.15,690.18,282.15Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,293c2.46-3.05,6.09-7.17,9.13-9.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.19,296.7s.63-.88,1.65-2.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.78,284.62s3.66,5.17,4.33,10.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.64,287.68s1-.6.63,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.31,281.56s2.09-1.85,1-5.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 677.48,
    y1: 284.7,
    x2: 675.99,
    y2: 281.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.34,287.49s-4.74-3.58-7.7-3.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.64,272.39s-.15,5.43-4.39,5.7-6.86-6.8-11.19-5.1-4.76,9.44-4.76,9.44,4.12-3.38,6.33-1.68,1.7,4.34.51,3.93-7.64-1.86-7.87,3a10.28,10.28,0,0,0,2.7,7.62s4.58-8.57,7.92-7-2.76,2.92-5.19,6.08-4,6.5-1.86,7.64a31.76,31.76,0,0,1,5.06,3.9,11.87,11.87,0,0,1,2.1-8c2.68-3.48,4.9-1.77,2.46,1.39s-1.23,8.13-1.23,8.13,7.19.5,12.33-1.59,5.16-4.09,3.51-5.87-7.38-4.17-5.67-6.38,6.1,9.74,8.61,7.14,3.27-5.55,1.86-7.64l-1.41-2.1s-5.72-2.39-7.37-4.17.73-.95,3.43.13,8.57,4.58,9,3.39-1.5-7.21-2.6-9.06-9.42-.2-10.37-.94,3.56-3.3,5-3.2a29,29,0,0,1,3.19.44s.12-3.44-4.55-6.53S703.64,272.39,703.64,272.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.64,272.39s-.15,5.43-4.39,5.7-6.86-6.8-11.19-5.1-4.76,9.44-4.76,9.44,4.12-3.38,6.33-1.68,1.7,4.34.51,3.93-7.64-1.86-7.87,3a10.28,10.28,0,0,0,2.7,7.62s4.58-8.57,7.92-7-2.76,2.92-5.19,6.08-4,6.5-1.86,7.64a31.76,31.76,0,0,1,5.06,3.9,11.87,11.87,0,0,1,2.1-8c2.68-3.48,4.9-1.77,2.46,1.39s-1.23,8.13-1.23,8.13,7.19.5,12.33-1.59,5.16-4.09,3.51-5.87-7.38-4.17-5.67-6.38,6.1,9.74,8.61,7.14,3.27-5.55,1.86-7.64l-1.41-2.1s-5.72-2.39-7.37-4.17.73-.95,3.43.13,8.57,4.58,9,3.39-1.5-7.21-2.6-9.06-9.42-.2-10.37-.94,3.56-3.3,5-3.2a29,29,0,0,1,3.19.44s.12-3.44-4.55-6.53S703.64,272.39,703.64,272.39Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.46,299c-1.37-4.54-3-11-2.92-15.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.22,304.34s-.45-1.23-1.07-3.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.39,282.49s7.67-.13,13.47,2.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.63,288.73s.1-1.44,6.43,3.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.33,281.88s-.44-3.36-4.89-4.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 697.54,
    y1: 286.85,
    x2: 693.79,
    y2: 286.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.19,291.89s-6.82,2.31-9,5.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.15,308.53s21.57,36.57,21.21,91.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75,304.76s-.69,6.25-5.6,6.16-7.28-8.5-12.44-6.94-6.38,10.44-6.38,10.44,5.07-3.51,7.46-1.33,1.56,5.16.22,4.57-8.65-2.86-9.36,2.73a11.89,11.89,0,0,0,2.39,9.05s6.1-9.45,9.8-7.33-3.46,3.11-6.57,6.53-5.23,7.12-2.86,8.64a36.82,36.82,0,0,1,5.47,5,13.75,13.75,0,0,1,3.17-9c3.43-3.76,5.82-1.58,2.71,1.84s-2.18,9.27-2.18,9.27,8.24,1.25,14.37-.68,6.34-4.23,4.6-6.44-8.11-5.5-5.93-7.9,6.12,11.82,9.26,9.06,4.3-6.1,2.87-8.65l-1.43-2.55s-6.38-3.3-8.12-5.51.93-1,3.95.47,9.45,6.1,10,4.76-1.05-8.46-2.14-10.7-10.85-1.12-11.88-2.05,4.42-3.49,6.07-3.24a36,36,0,0,1,3.64.81s.47-3.95-4.63-8S684.75,304.76,684.75,304.76Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75,304.76s-.69,6.25-5.6,6.16-7.28-8.5-12.44-6.94-6.38,10.44-6.38,10.44,5.07-3.51,7.46-1.33,1.56,5.16.22,4.57-8.65-2.86-9.36,2.73a11.89,11.89,0,0,0,2.39,9.05s6.1-9.45,9.8-7.33-3.46,3.11-6.57,6.53-5.23,7.12-2.86,8.64a36.82,36.82,0,0,1,5.47,5,13.75,13.75,0,0,1,3.17-9c3.43-3.76,5.82-1.58,2.71,1.84s-2.18,9.27-2.18,9.27,8.24,1.25,14.37-.68,6.34-4.23,4.6-6.44-8.11-5.5-5.93-7.9,6.12,11.82,9.26,9.06,4.3-6.1,2.87-8.65l-1.43-2.55s-6.38-3.3-8.12-5.51.93-1,3.95.47,9.45,6.1,10,4.76-1.05-8.46-2.14-10.7-10.85-1.12-11.88-2.05,4.42-3.49,6.07-3.24a36,36,0,0,1,3.64.81s.47-3.95-4.63-8S684.75,304.76,684.75,304.76Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.72,335.2c-1.15-5.36-2.45-12.95-1.91-18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.25,341.58s-.4-1.46-.94-3.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.05,316.11s8.86.56,15.26,4.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.73,323.33s.25-1.65,7.09,4.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.41,315s-.18-3.92-5.19-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 676.34,
    y1: 320.87,
    x2: 672.05,
    y2: 320.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.62,326.75s-8.09,2-10.89,5.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75,357s-.69,6.25-5.6,6.15-7.28-8.49-12.44-6.94-6.38,10.45-6.38,10.45,5.07-3.52,7.46-1.34,1.56,5.17.22,4.57-8.65-2.86-9.36,2.74a11.89,11.89,0,0,0,2.39,9s6.1-9.45,9.8-7.34-3.46,3.11-6.57,6.53-5.23,7.12-2.86,8.65a36.25,36.25,0,0,1,5.47,5,13.74,13.74,0,0,1,3.17-9c3.43-3.76,5.82-1.59,2.71,1.83s-2.18,9.27-2.18,9.27,8.24,1.25,14.37-.68,6.34-4.22,4.6-6.43-8.11-5.51-5.93-7.9,6.12,11.82,9.26,9.05,4.3-6.09,2.87-8.64l-1.43-2.56s-6.38-3.29-8.12-5.5.93-1,3.95.46,9.45,6.1,10,4.77-1.05-8.46-2.14-10.7-10.85-1.13-11.88-2.06,4.42-3.48,6.07-3.23a36,36,0,0,1,3.64.81s.47-3.95-4.63-8S684.75,357,684.75,357Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.75,357s-.69,6.25-5.6,6.15-7.28-8.49-12.44-6.94-6.38,10.45-6.38,10.45,5.07-3.52,7.46-1.34,1.56,5.17.22,4.57-8.65-2.86-9.36,2.74a11.89,11.89,0,0,0,2.39,9s6.1-9.45,9.8-7.34-3.46,3.11-6.57,6.53-5.23,7.12-2.86,8.65a36.25,36.25,0,0,1,5.47,5,13.74,13.74,0,0,1,3.17-9c3.43-3.76,5.82-1.59,2.71,1.83s-2.18,9.27-2.18,9.27,8.24,1.25,14.37-.68,6.34-4.22,4.6-6.43-8.11-5.51-5.93-7.9,6.12,11.82,9.26,9.05,4.3-6.09,2.87-8.64l-1.43-2.56s-6.38-3.29-8.12-5.5.93-1,3.95.46,9.45,6.1,10,4.77-1.05-8.46-2.14-10.7-10.85-1.13-11.88-2.06,4.42-3.48,6.07-3.23a36,36,0,0,1,3.64.81s.47-3.95-4.63-8S684.75,357,684.75,357Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.72,387.47c-1.15-5.37-2.45-13-1.91-18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.25,393.85s-.4-1.47-.94-3.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.05,368.38s8.86.56,15.26,4.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.73,375.59s.25-1.65,7.09,4.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.41,367.28s-.18-3.91-5.19-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 676.34,
    y1: 373.13,
    x2: 672.05,
    y2: 372.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.62,379s-8.09,2-10.89,5.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.56,352s13.89,32.92,15.36,48.64l-2.93-75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.2,344.36c-18.28-3.29-18.28,56.31-18.28,56.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.11,400.31s-10.6-99.46,20.11-99.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.23,342.14c-2.5-2.81-7.8-2.81-10.92,4.37s-.32,5.93-.32,5.93,5.93-1.87,9.68-3.12,8.74-4.37,9.05-2.5-2.5,3.75-5.93,4.37-12.48,3.12-11.55,5,3.12,7.5,3.12,7.5a79.36,79.36,0,0,1,8.43-6.25c4.06-2.49,6.56-1.56,4.37,1.25s-8.43,5.93-7.18,9.68,8.74,8.42,8.74,8.42.94-7.8,3.12-10.3,2.19.32,1.56,4.69a51.22,51.22,0,0,0-.62,5.61l8.74,3.13a62,62,0,0,1,4.68-6.25l1.56-1.56s-6.87-5.93-7.18-9.67,4.68,0,6.24.62,4.06,5,4.06,5,1.56-7.17,1.87-9.67l.32-2.5s-6.56-2.49-9.06-2.49-3.74,1.87-3.74-.63,2.5-4.06,5.31-3.74a48.84,48.84,0,0,1,7.49,1.87s1.87-1.56,1.24-6.24-2.18-4.69-5.93-3.44-6.24,4.06-9,4.06-1.25-3.43.63-4.37,6.55-2.81,7.49-3.12-5-4.68-8.12-5.31-7.16,1.58-6.86,4.68C705.09,343.7,695.73,345,693.23,342.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.32,374.28c.1.94.16,1.88.2,2.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.05,351.87a82.94,82.94,0,0,1,5.88,19.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.93,349.36c-1.55-3.32-2.71-5.35-2.71-5.35a9.26,9.26,0,0,0,4.06-3.74,10.32,10.32,0,0,1,3.12-3.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.29,354.62s11.24-4.68,11.24-3.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.77,348.69s5-2.49,9.37-2.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.9,356.18a43.53,43.53,0,0,0-5.93,5.93,27,27,0,0,0-4.37,7.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.33,357.43s6.56-1.87,10,1.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.21,315.26c-3.4-2-7.16-2.06-9-4.18s1.77-3.19,3.71-2.39,6.42,3.11,7.26,3.61.27-6.84-1.31-9.61-5.88-4.37-8-2.11c-4.54,4.77-11.62-1.49-11.13-5.21s-3-7.74-10.46-5.39-4.69,3.65-4.69,3.65,5.3,3.26,8.7,5.26,9,3.74,7.82,5.2-4.46.57-7.18-1.61-10.55-7.38-11.35-5.45-3.61,7.27-3.61,7.27a78.58,78.58,0,0,1,10.24,2.27c4.55,1.43,5.48,3.93,1.92,4.12s-10-2.48-12,.92-.63,12.13-.63,12.13,6.5-4.41,9.82-4.4,1.2,1.86-2.51,4.25a49.73,49.73,0,0,0-4.65,3.21l3.37,8.65a61.12,61.12,0,0,1,7.78-.56l2.2.15s0-9.07,2.6-11.76,3.07,3.54,3.62,5.12-1.11,6.34-1.11,6.34,6.45-3.53,8.54-4.93l2.09-1.4s-2.41-6.59-4.05-8.47-3.87-1.6-2-3.24,4.7-.77,6.3,1.55a48.56,48.56,0,0,1,3.5,6.89s2.4.39,5.53-3.15S726.6,317.27,723.21,315.26Zm-29.54,10c-2.5-1.25,3.43-3.75,3.43-3.75C699.29,321.19,696.16,326.5,693.67,325.25Zm4.2-11.65c-1.06-.54,2.13-1.6,2.13-1.6C704.61,312.89,698.94,314.13,697.87,313.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.6,331.61c-.65.68-1.31,1.35-2,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.41,312.18a82.87,82.87,0,0,1-10.75,17.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.57,309.69c1.49-3.35,2.26-5.55,2.26-5.55a9.28,9.28,0,0,0,5.49.61,10.3,10.3,0,0,1,4.87-.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.66,302.84s10.9,5.42,10.19,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.59,312.16s5.16,2.13,8,5.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.71,315.65a43.11,43.11,0,0,0-8.37-.59,26.85,26.85,0,0,0-8.28,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705,319.06s5.71,3.73,5.6,8.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.71,358.51c-2.74-1.62-5.76-1.66-7.25-3.36s1.43-2.57,3-1.93,5.16,2.5,5.85,2.91.21-5.51-1.06-7.73-4.73-3.53-6.47-1.71c-3.65,3.84-9.35-1.19-9-4.19s-2.41-6.22-8.42-4.33-3.77,2.94-3.77,2.94,4.27,2.61,7,4.23,7.27,3,6.3,4.18-3.6.46-5.79-1.3-8.48-5.94-9.12-4.38-2.91,5.85-2.91,5.85a63.91,63.91,0,0,1,8.24,1.83c3.66,1.14,4.41,3.16,1.55,3.31s-8-2-9.67.74-.51,9.76-.51,9.76,5.23-3.55,7.9-3.54,1,1.49-2,3.42a41.33,41.33,0,0,0-3.74,2.59l2.71,6.95a51.16,51.16,0,0,1,6.27-.45l1.77.13s0-7.3,2.09-9.47,2.47,2.85,2.92,4.13-.9,5.1-.9,5.1,5.19-2.84,6.87-4l1.68-1.13s-1.94-5.3-3.26-6.82-3.11-1.28-1.59-2.6,3.78-.62,5.07,1.25a39.66,39.66,0,0,1,2.82,5.54s1.93.31,4.45-2.54S677.44,360.12,674.71,358.51Zm-23.78,8c-2-1,2.77-3,2.77-3C655.46,363.28,652.94,367.55,650.93,366.55Zm3.39-9.38c-.86-.43,1.71-1.29,1.71-1.29C659.74,356.6,655.18,357.6,654.32,357.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.88,371.66c-.52.56-1.06,1.09-1.61,1.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.19,356a66.68,66.68,0,0,1-8.65,13.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.12,354c1.2-2.7,1.82-4.47,1.82-4.47a7.42,7.42,0,0,0,4.42.49,8.35,8.35,0,0,1,3.92-.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.73,348.52s8.77,4.36,8.2,4.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.55,356a20.21,20.21,0,0,1,6.46,4.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,358.82a35,35,0,0,0-6.73-.47,21.75,21.75,0,0,0-6.67,1.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.07,361.57s4.59,3,4.51,6.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.55,307s-3.43,2.49-5.61,0,.93-7.49-2.19-9.37-8.11,1.56-8.11,1.56,4.05.94,4.05,3.12-1.87,3.13-2.18,2.19-2.5-5.62-5.62-3.43a8,8,0,0,0-3.43,5.3s7.49-1.25,8.11,1.56-3.12-.31-6.24-.31-5.93.62-5.62,2.5a24.73,24.73,0,0,1,0,5,9.28,9.28,0,0,1,5.93-2.5c3.44,0,3.44,2.19.31,2.19s-5.61,3.12-5.61,3.12,3.12,4.68,6.86,6.87,5,1.25,5.31-.63-.94-6.55,1.25-6.55-3.12,8.43-.31,8.74,5-.63,5.61-2.5l.63-1.87s-1.25-4.68-.94-6.56.94,0,1.56,2.19,1.25,7.49,2.19,7.18,3.74-4.37,4.37-5.93-4.37-5.93-4.37-6.87,3.74.62,4.37,1.56,1.25,2.19,1.25,2.19,2.18-1.56,1.87-5.93S663.55,307,663.55,307Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.07,318.29c2.16-3,5.36-7.11,8.12-9.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.58,322s.55-.87,1.44-2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.75,309.78s3.75,4.68,4.68,9.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652,312.9s.93-.63.93,5.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.19,307s1.87-1.88.63-5.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 651.69,
    y1: 310.09,
    x2: 650.13,
    y2: 307.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.89,312.9s-4.69-3.12-7.5-3.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694,373.3s-3.43,2.5-5.62,0,.94-7.49-2.18-9.36-8.12,1.56-8.12,1.56,4.06.93,4.06,3.12-1.87,3.12-2.18,2.18-2.5-5.62-5.62-3.43a8,8,0,0,0-3.43,5.31s7.49-1.25,8.11,1.56-3.12-.32-6.24-.32-5.93.63-5.62,2.5a24.73,24.73,0,0,1,0,5,9.3,9.3,0,0,1,5.93-2.49c3.43,0,3.43,2.18.31,2.18s-5.62,3.12-5.62,3.12,3.13,4.69,6.87,6.87,5,1.25,5.31-.62-.94-6.56,1.25-6.56-3.13,8.43-.32,8.74,5-.62,5.62-2.5l.63-1.87s-1.25-4.68-.94-6.55.94,0,1.56,2.18,1.25,7.49,2.18,7.18,3.75-4.37,4.37-5.93-4.37-5.93-4.37-6.87,3.75.63,4.37,1.56a23.19,23.19,0,0,1,1.25,2.19s2.19-1.56,1.88-5.93S694,373.3,694,373.3Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.49,384.62c2.15-3,5.35-7.11,8.12-9.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674,388.28s.55-.86,1.44-2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.17,376.11s3.74,4.68,4.68,9.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.42,379.23s.94-.62.94,5.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.61,373.3s1.87-1.87.62-5.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 682.11,
    y1: 376.42,
    x2: 680.55,
    y2: 373.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.3,379.23s-4.68-3.12-7.49-3.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.95,
    y: 399.27,
    width: 24.13,
    height: 34.73,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 434,
    x2: 712,
    y2: 434,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.18,74.62l-1.46-.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.81,73.61a155.42,155.42,0,0,0-137.29,37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.983449935913086,2.983449935913086"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,111.58l-1.09,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.88 63.54 413.93 79.55 431.77 78.43 421.88 63.54",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.19,
    y: 102.42,
    width: 83.12,
    height: 143.63,
    transform: "translate(22.29 -46.36) rotate(6.46)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.14,110.77,380,227.06a4.65,4.65,0,0,1,4.1,5.15,4.6,4.6,0,0,1-1.14,2.54l63.13,7.15a4.64,4.64,0,0,1,4.61-6.83l13.17-116.29a4.65,4.65,0,0,1-4.1-5.15l-61.45-7A4.66,4.66,0,0,1,393.14,110.77Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.75,
    cy: 174.24,
    r: 21.61,
    transform: "translate(208.77 577.81) rotate(-84.62)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.62,173.72l2.08.27-.46,3.59-2.08-.27c-1,3-3.64,4.33-7.43,3.84l-.88-.11.54-4.15,1.15.14c2,.26,2.86-.44,3-1.84s-.48-2.29-2.47-2.55c-5.75-.74-7.13,7.81-15.12,6.79-3.79-.49-6-2.44-6.26-5.63l-2-.26.46-3.6,2,.26c1-3.07,3.68-4.35,7.48-3.87l1.91.25-.53,4.15-2.19-.28c-2-.26-2.83.53-3,1.93s.43,2.37,2.42,2.62c5.75.74,7.13-7.81,15.12-6.79C433.14,168.69,435.34,170.56,435.62,173.72Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.5,
    y: 98.99,
    width: 83.12,
    height: 143.63,
    transform: "translate(-4.49 10.18) rotate(-1.55)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,111.94l3.18,117a4.66,4.66,0,0,1,4.78,4.53,4.73,4.73,0,0,1-.77,2.68l63.5-1.72a4.57,4.57,0,0,1-.91-2.64,4.65,4.65,0,0,1,4.52-4.78L407,110a4.65,4.65,0,0,1-4.78-4.52l-61.82,1.67A4.66,4.66,0,0,1,335.87,111.94Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.06,
    cy: 170.8,
    r: 21.61,
    transform: "translate(-4.67 331.01) rotate(-47.58)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.77,168l2.09-.06.1,3.62-2.09.07c-.55,3.15-2.92,4.83-6.74,4.94l-.89,0-.12-4.19,1.17,0c2-.06,2.75-.89,2.71-2.29s-.83-2.19-2.84-2.14c-5.8.17-5.83,8.83-13.88,9.07-3.82.11-6.32-1.47-7.06-4.59l-2.05.06-.1-3.62,2.05-.06c.55-3.2,3-4.88,6.78-5l1.93-.06L368,168l-2.21.06c-2,.06-2.71,1-2.67,2.37s.79,2.28,2.8,2.22c5.8-.17,5.83-8.83,13.88-9.06C383.53,163.47,386,165,386.77,168Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.92,
    y: 101.55,
    width: 83.12,
    height: 143.63,
    transform: "translate(-36.64 121.75) rotate(-18.5)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.76,127.9l37.13,111a4.65,4.65,0,0,1,5.89,2.93,4.59,4.59,0,0,1,.05,2.79l60.24-20.15a4.61,4.61,0,0,1-1.64-2.26,4.66,4.66,0,0,1,2.93-5.89l-37.13-111a4.66,4.66,0,0,1-5.89-2.94L305.69,122A4.65,4.65,0,0,1,302.76,127.9Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.48,
    cy: 173.37,
    r: 21.61,
    transform: "translate(39.66 411.45) rotate(-63.01)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,165.4l1.9-.89,1.53,3.29-1.89.88c.74,3.12-.77,5.6-4.23,7.22l-.8.37-1.77-3.79,1.05-.5c1.83-.85,2.18-1.9,1.58-3.18s-1.63-1.68-3.45-.83c-5.25,2.45-1.85,10.42-9.14,13.82-3.47,1.62-6.39,1.16-8.31-1.41l-1.86.87L340.11,178l1.86-.87c-.76-3.16.78-5.66,4.25-7.27L348,169l1.77,3.79-2,.94c-1.83.85-2.11,2-1.51,3.24s1.62,1.77,3.45.92c5.25-2.45,1.84-10.42,9.14-13.82C362.25,162.48,365.1,162.88,367,165.4Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.54,
    y: 109.4,
    width: 83.12,
    height: 143.63,
    transform: "translate(-41.66 236.1) rotate(-36.51)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.9,154.27l69.62,94.07a4.66,4.66,0,0,1,7.42,3.62L401,214.16a4.64,4.64,0,0,1-1.29-8.14L330.09,112a4.66,4.66,0,0,1-6.51-1l-49.71,36.79A4.65,4.65,0,0,1,272.9,154.27Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.1,
    cy: 181.21,
    r: 21.61,
    transform: "translate(-45.38 194.78) rotate(-30.29)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,169.34l1.4-1.56,2.7,2.42-1.4,1.56c1.9,2.58,1.49,5.45-1.06,8.3l-.59.66-3.12-2.8.78-.87c1.34-1.49,1.25-2.6.2-3.54s-2.15-.91-3.5.59c-3.87,4.31,2.38,10.3-3,16.3-2.56,2.84-5.42,3.57-8.19,1.95l-1.37,1.53-2.7-2.42,1.37-1.53c-1.94-2.6-1.5-5.51,1.06-8.35l1.29-1.44,3.12,2.8-1.48,1.64c-1.35,1.5-1.17,2.63-.12,3.57s2.19,1,3.53-.5c3.87-4.32-2.38-10.31,3-16.3C339.09,168.53,341.88,167.78,344.64,169.34Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.25,
    y: 132.92,
    width: 83.12,
    height: 143.63,
    transform: "translate(-61.19 229.68) rotate(-37.59)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.12,179l71.39,92.74a4.64,4.64,0,0,1,7.48,3.47l50.34-38.76a4.64,4.64,0,0,1-1.44-8.12L298.5,135.61a4.65,4.65,0,0,1-6.53-.85l-49,37.72A4.67,4.67,0,0,1,242.12,179Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.81,
    cy: 204.73,
    r: 21.61,
    transform: "translate(64.09 482.46) rotate(-82.56)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,193l1.42-1.54,2.66,2.45-1.41,1.54c1.87,2.61,1.42,5.47-1.17,8.29l-.6.65-3.08-2.84.79-.86c1.36-1.48,1.29-2.59.25-3.54s-2.15-.94-3.51.54c-3.93,4.27,2.25,10.34-3.2,16.26-2.59,2.82-5.47,3.51-8.22,1.85L297,217.28l-2.66-2.45,1.39-1.51c-1.91-2.63-1.43-5.53,1.16-8.34l1.31-1.42,3.08,2.83-1.5,1.63c-1.36,1.48-1.2,2.62-.16,3.57s2.17,1,3.54-.46c3.92-4.26-2.25-10.33,3.2-16.26C309,192.09,311.76,191.37,314.5,193Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 166.44,
    width: 83.12,
    height: 143.63,
    transform: "translate(-66.96 355.04) rotate(-57.73)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,236.39l99,62.48a4.65,4.65,0,0,1,8.22.68l33.92-53.71a4.65,4.65,0,0,1-4.15-7.13l-99-62.49a4.65,4.65,0,0,1-6.42,1.46l-33,52.28A4.65,4.65,0,0,1,219,236.39Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.56,
    cy: 238.26,
    r: 21.61,
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.06,225.5l1.13-1.76,3.05,2-1.13,1.76c2.29,2.24,2.34,5.14.27,8.36l-.47.74-3.53-2.26.63-1c1.09-1.7.83-2.78-.36-3.54s-2.27-.55-3.36,1.14c-3.14,4.88,4,9.8-.36,16.57-2.07,3.22-4.78,4.39-7.77,3.24l-1.11,1.72-3.05-2,1.11-1.72c-2.33-2.26-2.36-5.2-.29-8.42l1.05-1.63,3.52,2.27-1.2,1.86c-1.09,1.69-.73,2.78.45,3.55s2.32.63,3.41-1.07c3.14-4.87-4-9.79.36-16.56C288.46,225.58,291.08,224.4,294.06,225.5Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.93,
    y: 193.11,
    width: 83.12,
    height: 143.63,
    transform: "translate(-56.24 454.46) rotate(-73.44)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,282l112.18,33.35a4.64,4.64,0,0,1,8.1-1.57l18.1-60.9a4.57,4.57,0,0,1-2.79,0,4.65,4.65,0,0,1-3.14-5.78L229.26,213.77a4.65,4.65,0,0,1-5.78,3.14l-17.63,59.28A4.65,4.65,0,0,1,209,282Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.49,
    cy: 264.93,
    r: 21.61,
    transform: "translate(-32.2 491.52) rotate(-80.06)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,251.2l.64-2,3.45,1.11-.64,2c2.8,1.58,3.59,4.37,2.42,8l-.27.84-4-1.28.36-1.11c.62-1.91.08-2.89-1.26-3.32s-2.34.05-3,2c-1.77,5.52,6.39,8.43,3.93,16.1-1.17,3.64-3.49,5.48-6.68,5.13l-.63,1.95-3.45-1.1.63-2c-2.83-1.58-3.62-4.41-2.45-8.06l.59-1.84,4,1.28-.68,2.11c-.61,1.92,0,2.88,1.35,3.31s2.41,0,3-1.91c1.78-5.52-6.38-8.43-3.92-16.1C273.12,252.72,275.35,250.9,278.51,251.2Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.52,
    y: 232.58,
    width: 83.12,
    height: 143.63,
    transform: "translate(574.55 36.53) rotate(90.23)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.07,269.06l-117-.47a4.64,4.64,0,0,1-7.33,3.78l-.26,63.53a4.57,4.57,0,0,1,2.67-.83,4.65,4.65,0,0,1,4.63,4.67l117,.47a4.66,4.66,0,0,1,4.68-4.64l.25-61.84A4.65,4.65,0,0,1,329.07,269.06Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.08,
    cy: 304.39,
    r: 21.61,
    transform: "translate(-105.38 462.01) rotate(-71.35)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31,318.1v2.09h-3.63v-2.09c-3.13-.66-4.74-3.08-4.72-6.91v-.88h4.19v1.17c0,2,.79,2.78,2.2,2.79s2.22-.76,2.22-2.77c0-5.8-8.63-6.12-8.59-14.17,0-3.82,1.67-6.27,4.81-6.9v-2.06l3.63,0v2.05c3.18.66,4.78,3.12,4.76,6.94v1.94l-4.18,0v-2.21c0-2-.87-2.75-2.28-2.75s-2.3.72-2.31,2.73c0,5.8,8.64,6.11,8.6,14.16C276,315,274.41,317.43,271.31,318.1Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.1,100.3a24.77,24.77,0,0,1,24.77-24.78H595a24.77,24.77,0,0,1,24.78,24.78V409.22A24.77,24.77,0,0,1,595,434H461.87a24.77,24.77,0,0,1-24.77-24.78Zm13.7,291.22c0,13.69,5.18,24.78,18.86,24.78H587.18A24.78,24.78,0,0,0,612,391.52V106a24.79,24.79,0,0,0-24.78-24.78H538l0,.18c-1.46,5.24-4.81,8.63-8.51,8.63h-2.14c-3.7,0-7.05-3.39-8.51-8.63l-.05-.18H469.66C456,81.18,450.8,92.28,450.8,106Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.42,81.18H549.29l0,.18c-1.45,5.24-4.8,8.63-8.51,8.63H538.6c-3.71,0-7.06-3.39-8.51-8.63l-.05-.18H480.91A24.78,24.78,0,0,0,456.13,106V405.54a14.22,14.22,0,0,0,14.22,14.22H609a14.22,14.22,0,0,0,14.22-14.22V106A24.78,24.78,0,0,0,598.42,81.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.44 110.25 454.8 162.38 454.8 261.19 468.36 273.07 562.98 165 500.44 110.25",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.15,163.49l-46.53-40.73a4.64,4.64,0,0,1-6.56.43L454.8,171.46v80l11,9.64a4.65,4.65,0,0,1,7.69-3l77.09-88.06A4.65,4.65,0,0,1,550.15,163.49Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484.4,
    cy: 191.66,
    r: 21.61,
    transform: "matrix(0.02, -1, 1, 0.02, 283.39, 672.25)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.68,199.73l1.48,1.48-2.56,2.56-1.48-1.48c-2.68,1.76-5.53,1.18-8.23-1.52l-.62-.63,3-3,.83.83c1.42,1.43,2.53,1.4,3.53.4s1-2.1-.4-3.53c-4.09-4.1-10.42,1.81-16.1-3.9-2.7-2.71-3.27-5.61-1.5-8.28l-1.45-1.46,2.57-2.56,1.45,1.46c2.71-1.79,5.58-1.19,8.28,1.52l1.37,1.37-3,3-1.56-1.57c-1.42-1.43-2.56-1.32-3.56-.32s-1.11,2.13.31,3.56c4.09,4.1,10.42-1.81,16.1,3.9C496.8,194.24,497.4,197.06,495.68,199.73Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.91 145.77 454.8 205.53 454.8 256.98 474.56 290.4 598.21 217.32 555.91 145.77",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,211.89,555,158.65a4.66,4.66,0,0,1-6.38-1.64L454.8,212.48V242.6l21.07,35.65a4.64,4.64,0,0,1,8.23-.44l100.76-59.55A4.64,4.64,0,0,1,586.5,211.89Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.23,
    cy: 218.09,
    r: 21.61,
    transform: "translate(180.38 666.31) rotate(-76.18)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,229.63l.87,1.91-3.3,1.5-.87-1.91c-3.12.71-5.59-.82-7.17-4.3l-.37-.81,3.81-1.73.49,1.06c.83,1.84,1.88,2.2,3.16,1.62s1.7-1.62.87-3.45c-2.4-5.28-10.4-2-13.73-9.28-1.58-3.48-1.1-6.4,1.5-8.29l-.85-1.87,3.29-1.5.85,1.87c3.17-.73,5.65.84,7.23,4.32l.8,1.76-3.81,1.74-.92-2c-.83-1.83-1.94-2.13-3.22-1.54s-1.79,1.61-1,3.44c2.4,5.28,10.4,1.95,13.73,9.28C526,224.88,525.56,227.73,523,229.63Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.58 184.04 454.8 208.75 454.8 218.43 467.61 290.89 609.04 265.89 594.58 184.04",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.83,192,468.59,212.39a4.66,4.66,0,0,1-3.78,5.39,4.61,4.61,0,0,1-2.76-.37L473.1,280a4.65,4.65,0,0,1,7.87,2.48l115.25-20.37a4.65,4.65,0,0,1,3.77-5.39l-10.76-60.9A4.66,4.66,0,0,1,583.83,192Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 531.09,
    cy: 237.47,
    r: 21.61,
    transform: "translate(29.53 532.24) rotate(-54.53)",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.62,250.69l.33,2.07-3.57.58-.34-2.07c-3.2-.13-5.18-2.26-5.79-6l-.14-.88,4.13-.67.19,1.15c.32,2,1.24,2.62,2.63,2.39s2.06-1.11,1.74-3.1c-.93-5.72-9.52-4.61-10.81-12.56-.62-3.77.62-6.46,3.62-7.6l-.33-2,3.57-.58.33,2c3.24.12,5.23,2.29,5.84,6.07l.31,1.9-4.13.68-.36-2.19c-.32-2-1.31-2.56-2.7-2.34s-2.15,1.09-1.83,3.08c.93,5.72,9.52,4.61,10.81,12.56C539.73,246.88,538.57,249.52,535.62,250.69Z",
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.1,
    y: 178.87,
    width: 83.12,
    height: 143.63,
    transform: "translate(792.01 -291.14) rotate(89.96)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.49,215.07l-117,.07a4.65,4.65,0,0,1-7.32,3.82l0,63.53a4.64,4.64,0,0,1,7.32,3.8l117-.07a4.66,4.66,0,0,1,4.65-4.66l0-61.84A4.66,4.66,0,0,1,601.49,215.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.66,
    cy: 250.68,
    r: 21.61,
    transform: "translate(-38.54 110.67) rotate(-11.27)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,264.38v2.09h-3.62v-2.09c-3.14-.64-4.75-3.06-4.76-6.88v-.89h4.19v1.17c0,2,.81,2.78,2.22,2.77s2.21-.76,2.21-2.77c0-5.8-8.66-6.08-8.66-14.13,0-3.83,1.64-6.28,4.78-6.93v-2.05h3.62v2.05c3.18.64,4.79,3.1,4.79,6.92v1.93h-4.18v-2.22c0-2-.88-2.74-2.29-2.73s-2.3.72-2.3,2.73c0,5.8,8.66,6.08,8.67,14.13C548.62,261.27,547.05,263.69,544,264.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.3,
    cy: 332,
    r: 20,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.3,342l-11.4-15.2a3,3,0,1,1,4.8-3.6l6.6,8.8,15.6-20.8a3,3,0,1,1,4.8,3.6Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.2,116V106a24.78,24.78,0,0,0-24.78-24.78H549.29l0,.18c-1.45,5.24-4.8,8.63-8.51,8.63H538.6c-3.71,0-7.06-3.39-8.51-8.63l-.05-.18H480.91A24.78,24.78,0,0,0,456.13,106v10Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.13,399v6.54a14.22,14.22,0,0,0,14.22,14.22H609a14.22,14.22,0,0,0,14.22-14.22V399Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,100.3a24.77,24.77,0,0,0-24.78-24.78H473.12a24.78,24.78,0,0,0-24.78,24.78V409.22A24.78,24.78,0,0,0,473.12,434H606.21A24.77,24.77,0,0,0,631,409.22ZM623.2,391.52a24.77,24.77,0,0,1-24.78,24.78H480.91a24.77,24.77,0,0,1-24.78-24.78V106a24.78,24.78,0,0,1,24.78-24.78H530l.05.18c1.45,5.24,4.8,8.63,8.51,8.63h2.13c3.71,0,7.06-3.39,8.51-8.63l0-.18h49.13A24.78,24.78,0,0,1,623.2,106Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.87,78.93H477.46a26.25,26.25,0,0,0-26.25,26.25V404.34a26.25,26.25,0,0,0,26.25,26.25H601.87a26.25,26.25,0,0,0,26.25-26.25V105.18A26.25,26.25,0,0,0,601.87,78.93ZM623.2,391.52a24.77,24.77,0,0,1-24.78,24.78H480.91a24.77,24.77,0,0,1-24.78-24.78V106a24.78,24.78,0,0,1,24.78-24.78H530l.05.18c1.45,5.24,4.8,8.63,8.51,8.63h2.13c3.71,0,7.06-3.39,8.51-8.63l0-.18h49.13A24.78,24.78,0,0,1,623.2,106Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.48,82.37a2.33,2.33,0,1,0-2.32,2.33A2.32,2.32,0,0,0,541.48,82.37Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,91.28c0,2.36-2.65,3.2-2.66,5v.12h2.57v.79h-3.43v-.66c0-2.52,2.65-3,2.65-5.21,0-.81-.27-1.23-.92-1.23s-.91.46-.91,1.15v.69h-.82v-.64c0-1.19.55-2,1.76-2S471,90.09,471,91.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.25,91.27v.2a1.54,1.54,0,0,1-.95,1.61,1.55,1.55,0,0,1,.95,1.62v.6c0,1.19-.56,2-1.76,2s-1.75-.78-1.75-2v-.54h.81v.59c0,.71.29,1.13.92,1.13s.91-.41.91-1.2v-.61c0-.77-.32-1.13-1-1.16h-.47v-.78h.51a.94.94,0,0,0,.94-1.07v-.35c0-.81-.28-1.22-.91-1.22s-.92.44-.92,1.14v.4h-.81v-.36c0-1.19.55-2,1.75-2S475.25,90.08,475.25,91.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.94,91.86V93h-.84V91.86Zm0,4.25v1.08h-.84V96.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.7,92.57a1.24,1.24,0,0,1,1.16-.65c1,0,1.45.74,1.45,1.85V95.3c0,1.19-.57,2-1.76,2s-1.76-.78-1.76-2v-.53h.82v.58c0,.71.29,1.13.91,1.13s.92-.42.92-1.13V93.84c0-.7-.29-1.13-.92-1.13a.84.84,0,0,0-.88.84v.18h-.81l.21-4.34h3.08v.78h-2.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.65,91.26v.15h-.82v-.2c0-.71-.29-1.12-.92-1.12s-1,.42-1,1.26V93.1a1.26,1.26,0,0,1,1.26-.83c1,0,1.45.72,1.45,1.85V95.3c0,1.19-.59,2-1.78,2s-1.8-.78-1.8-2v-4c0-1.24.56-2,1.8-2S485.65,90.07,485.65,91.26ZM483,94.18v1.17c0,.71.29,1.13.93,1.13s.92-.42.92-1.13V94.18c0-.7-.3-1.12-.92-1.12S483,93.48,483,94.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.67,
    y: 91.6,
    width: 2.2,
    height: 5.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.61,
    y: 90.5,
    width: 2.2,
    height: 6.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.55,
    y: 89.72,
    width: 2.2,
    height: 7.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.49,
    y: 88.35,
    width: 2.2,
    height: 8.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607,97H593.75V88.88H607Zm-12.49-.73h11.76V89.62H594.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.59,
    y: 90.42,
    width: 6.98,
    height: 5.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.52,
    y: 91.97,
    width: 1.66,
    height: 1.9,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.9,95.21a.55.55,0,0,1-.25-.07c-2.7-1.6-4.47-.12-4.55-.06a.48.48,0,0,1-.69,0,.49.49,0,0,1,0-.69c.1-.08,2.37-2,5.7,0a.5.5,0,0,1-.25.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.89,93.55a.59.59,0,0,1-.25-.07c-3.89-2.32-6.51-.08-6.53-.06a.5.5,0,0,1-.7,0,.49.49,0,0,1,.05-.7s3.18-2.73,7.69-.05a.49.49,0,0,1,.17.67A.5.5,0,0,1,589.89,93.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.8,91.62a.43.43,0,0,1-.25-.07c-4.93-2.93-8.21-.17-8.35,0a.48.48,0,0,1-.69,0,.49.49,0,0,1,0-.69s3.93-3.37,9.5-.06a.49.49,0,0,1,.17.68A.47.47,0,0,1,590.8,91.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.41,96a1.24,1.24,0,0,1-2.48,0,1.24,1.24,0,0,1,2.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.97,
    y: 138.17,
    width: 5.2,
    height: 20.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324,100.3a24.78,24.78,0,0,0-24.78-24.78H166.15a24.77,24.77,0,0,0-24.78,24.78V409.22A24.77,24.77,0,0,0,166.15,434H299.24A24.78,24.78,0,0,0,324,409.22ZM310.31,391.52c0,13.69-5.17,24.78-18.86,24.78H173.94a24.77,24.77,0,0,1-24.78-24.78V106a24.78,24.78,0,0,1,24.78-24.78h49.13l.05.18c1.45,5.24,4.8,8.63,8.51,8.63h2.13c3.71,0,7.06-3.39,8.51-8.63l0-.18h49.13c13.69,0,18.86,11.1,18.86,24.78Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,81.18H232.89l0,.18C231.39,86.6,228,90,224.33,90H222.2c-3.71,0-7.06-3.39-8.51-8.63l-.05-.18H164.51A24.78,24.78,0,0,0,139.73,106V405.54A14.22,14.22,0,0,0,154,419.76H292.58a14.22,14.22,0,0,0,14.22-14.22V106A24.78,24.78,0,0,0,282,81.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "173.69 116.01 173.69 167.53 161.23 180 161.23 248.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.5 116.75 188.5 145.85 174.23 161.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.91,
    y1: 152.98,
    x2: 181.91,
    y2: 191.41,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.58,
    y1: 116.2,
    x2: 200.58,
    y2: 173.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.23,
    cy: 251.5,
    r: 2.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,193a2.12,2.12,0,1,0-2.12,2.12A2.12,2.12,0,0,0,184,193Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,175.81a2.12,2.12,0,1,0-2.12,2.12A2.12,2.12,0,0,0,202.55,175.81Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "267.82 116.01 267.82 167.53 280.29 180 280.29 248.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "253.01 116.75 253.01 145.85 267.29 161.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.6,
    y1: 152.98,
    x2: 259.6,
    y2: 191.41,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.94,
    y1: 116.2,
    x2: 240.94,
    y2: 173.3,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.17,251.5a2.12,2.12,0,1,1,2.12,2.12A2.11,2.11,0,0,1,278.17,251.5Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.66,
    cy: 192.95,
    r: 2.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,175.81a2.12,2.12,0,1,1,2.12,2.12A2.12,2.12,0,0,1,239,175.81Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,116V106A24.78,24.78,0,0,0,282,81.18H232.89l0,.18C231.39,86.6,228,90,224.33,90H222.2c-3.71,0-7.06-3.39-8.51-8.63l-.05-.18H164.51A24.78,24.78,0,0,0,139.73,106v10Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.73,399v6.54A14.22,14.22,0,0,0,154,419.76H292.58a14.22,14.22,0,0,0,14.22-14.22V399Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.59,100.3a24.77,24.77,0,0,0-24.78-24.78H156.72a24.78,24.78,0,0,0-24.78,24.78V409.22A24.78,24.78,0,0,0,156.72,434H289.81a24.77,24.77,0,0,0,24.78-24.78ZM306.8,391.52A24.77,24.77,0,0,1,282,416.3H164.51a24.77,24.77,0,0,1-24.78-24.78V106a24.78,24.78,0,0,1,24.78-24.78h49.13l.05.18c1.45,5.24,4.8,8.63,8.51,8.63h2.13c3.71,0,7.06-3.39,8.51-8.63l0-.18H282A24.78,24.78,0,0,1,306.8,106Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47,78.93H161.06a26.25,26.25,0,0,0-26.25,26.25V404.34a26.25,26.25,0,0,0,26.25,26.25H285.47a26.25,26.25,0,0,0,26.25-26.25V105.18A26.25,26.25,0,0,0,285.47,78.93ZM306.8,391.52A24.77,24.77,0,0,1,282,416.3H164.51a24.77,24.77,0,0,1-24.78-24.78V106a24.78,24.78,0,0,1,24.78-24.78h49.13l.05.18c1.45,5.24,4.8,8.63,8.51,8.63h2.13c3.71,0,7.06-3.39,8.51-8.63l0-.18H282A24.78,24.78,0,0,1,306.8,106Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,82.37a2.33,2.33,0,1,0-2.32,2.33A2.32,2.32,0,0,0,225.08,82.37Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,91.28c0,2.36-2.65,3.2-2.66,5v.12h2.57v.79h-3.43v-.66c0-2.52,2.65-3,2.65-5.21,0-.81-.27-1.23-.92-1.23s-.91.46-.91,1.15v.69h-.82v-.64c0-1.19.55-2,1.75-2S154.58,90.09,154.58,91.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,91.27v.2a1.54,1.54,0,0,1-.95,1.61,1.55,1.55,0,0,1,.95,1.62v.6c0,1.19-.56,2-1.76,2s-1.75-.78-1.75-2v-.54h.81v.59c0,.71.29,1.13.91,1.13s.92-.41.92-1.2v-.61c0-.77-.32-1.13-1-1.16h-.47v-.78H157a.94.94,0,0,0,.94-1.07v-.35c0-.81-.28-1.22-.92-1.22s-.91.44-.91,1.14v.4h-.81v-.36c0-1.19.55-2,1.75-2S158.85,90.08,158.85,91.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,91.86V93h-.83V91.86Zm0,4.25v1.08h-.83V96.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.3,92.57a1.24,1.24,0,0,1,1.16-.65c1,0,1.45.74,1.45,1.85V95.3c0,1.19-.57,2-1.76,2s-1.76-.78-1.76-2v-.53h.82v.58c0,.71.29,1.13.91,1.13s.92-.42.92-1.13V93.84c0-.7-.29-1.13-.92-1.13a.84.84,0,0,0-.88.84v.18h-.81l.21-4.34h3.08v.78h-2.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.25,91.26v.15h-.82v-.2c0-.71-.29-1.12-.92-1.12s-.95.42-.95,1.26V93.1a1.25,1.25,0,0,1,1.26-.83c1,0,1.45.72,1.45,1.85V95.3c0,1.19-.59,2-1.79,2s-1.79-.78-1.79-2v-4c0-1.24.56-2,1.79-2S169.25,90.07,169.25,91.26Zm-2.69,2.92v1.17c0,.71.29,1.13.92,1.13s.93-.42.93-1.13V94.18c0-.7-.3-1.12-.93-1.12S166.56,93.48,166.56,94.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.27,
    y: 91.6,
    width: 2.2,
    height: 5.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.21,
    y: 90.5,
    width: 2.2,
    height: 6.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.15,
    y: 89.72,
    width: 2.2,
    height: 7.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.09,
    y: 88.35,
    width: 2.2,
    height: 8.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.57,97H277.35V88.88h13.22Zm-12.49-.73h11.76V89.62H278.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.18,
    y: 90.42,
    width: 6.98,
    height: 5.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.11,
    y: 91.97,
    width: 1.66,
    height: 1.9,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,95.21a.52.52,0,0,1-.25-.07c-2.7-1.6-4.48-.12-4.55-.06a.49.49,0,0,1-.7,0,.5.5,0,0,1,.05-.69c.1-.08,2.37-2,5.7,0a.5.5,0,0,1-.25.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,93.55a.59.59,0,0,1-.25-.07c-3.89-2.32-6.51-.08-6.53-.06a.5.5,0,1,1-.66-.74s3.19-2.73,7.7-.05a.49.49,0,0,1,.17.67A.5.5,0,0,1,273.49,93.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4,91.62a.48.48,0,0,1-.26-.07c-4.92-2.93-8.2-.17-8.34,0a.48.48,0,0,1-.69,0,.49.49,0,0,1,0-.69s3.93-3.37,9.5-.06a.5.5,0,0,1,.17.68A.47.47,0,0,1,274.4,91.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,96a1.24,1.24,0,1,1-2.48,0A1.24,1.24,0,0,1,271,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.85,
    y: 138.17,
    width: 5.2,
    height: 20.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.85,
    y: 182.56,
    width: 5.2,
    height: 20.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.85,
    y: 205.22,
    width: 5.2,
    height: 20.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.18,219.22v.35H176.8v-.43c0-1.18-.45-1.87-1.5-1.87s-1.5.69-1.5,1.85c0,2.94,4.4,3.23,4.4,6.91,0,2-.95,3.28-2.95,3.28s-2.94-1.29-2.94-3.28v-.74h1.36v.82c0,1.18.49,1.87,1.54,1.87s1.53-.69,1.53-1.87c0-2.92-4.38-3.2-4.38-6.89,0-2,.94-3.28,2.9-3.28S178.18,217.23,178.18,219.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,221.88v1.31h-3.2v4.66h3.93v1.33h-5.39V216.07h5.39v1.33h-3.93v4.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,219.24v1.18h-1.39v-1.26c0-1.18-.47-1.89-1.53-1.89s-1.54.71-1.54,1.89v6.93c0,1.18.49,1.89,1.54,1.89s1.53-.71,1.53-1.89v-1.7H192V226c0,2-.94,3.29-3,3.29s-2.94-1.31-2.94-3.29v-6.78c0-2,.93-3.3,2.94-3.3S192,217.25,192,219.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,226.09c0,1.18.47,1.89,1.54,1.89s1.51-.71,1.51-1.89v-10h1.37v10c0,2-.92,3.31-2.94,3.31s-2.92-1.33-2.92-3.31v-10h1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.51,216.07c2.06,0,2.92,1.05,2.92,3v1.07c0,1.44-.51,2.34-1.63,2.69,1.2.36,1.65,1.33,1.65,2.74v2a3.2,3.2,0,0,0,.26,1.57h-1.48a3.43,3.43,0,0,1-.24-1.59v-2.06c0-1.48-.7-1.95-1.91-1.95h-1v5.6h-1.46V216.07Zm-.38,6.18c1.16,0,1.86-.37,1.86-1.8V219.2c0-1.18-.43-1.8-1.52-1.8h-1.42v4.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,221.88v1.31h-3.2v4.66h3.93v1.33H208V216.07h5.39v1.33h-3.93v4.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,216.07c2.06,0,2.94,1.22,2.94,3.2v1.58c0,2.08-1,3.16-3,3.16h-1.29v5.17h-1.46V216.07Zm-.11,6.63c1.09,0,1.61-.5,1.61-1.76V219.2c0-1.2-.43-1.8-1.5-1.8h-1.4v5.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79,226.54l-.5,2.64h-1.35l2.51-13.11h2.12l2.5,13.11h-1.46l-.5-2.64Zm.19-1.25h2.92l-1.48-7.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.62,224.48l-2.77-8.41h1.52l2,6.44,2.06-6.44h1.38l-2.79,8.41v4.7h-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,229.16h-1.41l-2.17-10.43v10.45h-1.27V216.07h2l2.15,10.47,2.08-10.47h2v13.11h-1.39V218.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36,221.88v1.31h-3.2v4.66h3.93v1.33H248.7V216.07h5.39v1.33h-3.93v4.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,229.18h-1.31V216.07h1.86l3,9.48v-9.48h1.29v13.11h-1.51l-3.36-10.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,229.18V217.4h-2.41v-1.33h6.27v1.33h-2.41v11.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,172.87v-4.34c0-8.58-5.7-11.62-11.54-11.62a11.22,11.22,0,0,0-11.41,11.62v4.34H207.9v24.07H234V172.87ZM221.7,186.1v4.36h-2.46V186.1a3.29,3.29,0,1,1,2.46,0Zm7.16-13.23H213v-4.34a7.93,7.93,0,0,1,7.92-7.93,7.59,7.59,0,0,1,7.93,7.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.43,
    y: 244.11,
    width: 91.33,
    height: 59.33,
    rx: 6,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.43,
    y: 253.45,
    width: 91.33,
    height: 16.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 280.08,
    width: 13.84,
    height: 13.84,
    rx: 3.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.05,
    y: 290.47,
    width: 32.88,
    height: 3.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.39,295.56l2.51,10.82s-3.3,3.76-6.27,2.35-4.08-9.25-4.08-9.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75,268.77a10.25,10.25,0,0,1,3.37,6c.57,3.75,9,28.75,9,28.75a18.91,18.91,0,0,0-9.22.75c-4.5,1.68-9.13-2.78-9.13-2.78L107.57,272",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,301l11.58-1.89a6.39,6.39,0,0,1,.74,4.39c-.5,2.46.07,3.35-1.64,4s-6.9-.09-8.31-2A20.39,20.39,0,0,1,113.84,301Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.74,
    y1: 292.02,
    x2: 115.99,
    y2: 280.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,300.6l0,0c2.45-8.74,7.42-23.45,8.38-26.61,1.32-4.31,3.56-5.43,3.56-5.43l3.37,21-1.31,2.81s-3.64,10.12-6.4,15.12l7.53,16L78,329.06l-3.37,4.87s-15.36-23.78-16.11-25.46S60.2,300.6,60.2,300.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.12,268.21a7.82,7.82,0,0,0-4.5,3.55c-1.87,3-11,33.15-11,33.15a15.27,15.27,0,0,0,6.55,2.81c3.75.56,3.71-.24,3.71-.24l7.53-13.81",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.55,299.35s-2.83,5.67-1.41,7.09,7.79,2.84,11.57,1.89l1-5S60.92,301.48,58.55,299.35Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.69 282.99 74.21 295.79 68 288.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,425.93s0,.76,4.75,4.76,5.71,5.14,4.38,6.47-7.8-1.14-9.89-2.47-1.15-1.34-3.62-2.48-1.33-5.14-.95-6.09S116.59,425.93,116.59,425.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,425.07s0,.76-4.75,4.76-5.71,5.13-4.38,6.47,7.8-1.15,9.9-2.48,1.14-1.33,3.61-2.47,1.33-5.14,1-6.09S70.57,425.07,70.57,425.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,353.85c-.6-6.4.75-19,.75-20.48s2.87-7.71,3.71-9.45l.08-2s29.6-1.12,33.51-2.52c0,0,4.56,16.06,5.12,31.14s3.07,33.51,2.52,44.13c-.45,8.49-.85,25.43-1.22,31.12a3,3,0,0,1-2.35,2.75l-.68.15a3,3,0,0,1-3.67-2.57c-1.37-11-6.45-48.1-8.56-54.91-2.51-8.1-7.68-30-7.68-30s-11.87,54-13.26,61.29-5.87,23.74-5.87,23.74a13.62,13.62,0,0,1-3.63.84,11.43,11.43,0,0,1-3.05-.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35,263.08s7.22,1.44,12.09,2.89,8.13,2.34,8.13,4-2.17,50.18-2.17,50.18-.18,2-4.51,2.53-27.26,1.26-28.71.9-2-1.8-2.16-4-5.78-48.2-5.42-50.36,18.05-5.42,18.6-5.6A7.75,7.75,0,0,1,94.35,263.08Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37,270c0,3.64-3.54,6.59-7.9,6.59s-7.91-2.95-7.91-6.59,3.54-6.58,7.91-6.58S100.37,266.37,100.37,270Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,268.58l20,12.51L92,304.36l8.17-.61L96.49,281.5l16.34-12.66-14.29-5.51s-.41,5.31-.82,7.14-1.7,3.85-5.55,3.76-5.88-5.59-5.88-5.59l.11-5.34S74,266.08,72.18,268.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.07,291s-7.46,16.7-17.4,25.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.55,320.43a12.35,12.35,0,0,1-2.38,1.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,305.56s-6.44,8.66-11.94,13.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.47,250.66s1.67-4.17,2.51-.83-2.09,7.51-3.76,6.26",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.37,251.7s-3.55-2.29-3.34.84,3.34,6.67,4.38,4.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22,256.09,98,269a5.5,5.5,0,0,1-5.84,5.21c-5.63,0-5.42-6.46-5.42-6.46L85.5,257.34S94.47,258.38,98.22,256.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,266.9c1.73-.32,3.91-2.35,5.61-4.24l.08-4.92-3.46-2.09a31.38,31.38,0,0,1-5.95.31l-2.9,2.77.54,4.57C87.94,265,90.39,267.28,92.48,266.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.87,248.72S78.36,241,85,236.42s13.76,1.25,14.6,7.09.21,13.56-2.92,17.94-5.07,4.69-8.55,2.08S81.07,253.73,80.87,248.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,244.21s-2.33,3.93-1,4.22,6.7-3.5,6.7-3.5-1,2.19,1.16,2.19,4.66-5.53,4.66-5.53a4.79,4.79,0,0,0,.72,3.2c1,1.45,2.19,3.35,2.19,3.35l.14.87,1.6-.87s-.14-7.57-.29-8.73,2.91,2.32,3.06-.15-6.7-6.4-7.28-6.69,3.78,0,2.91-1.17-7-2.76-9.31-1.89a71.19,71.19,0,0,0-7.86,4.37s-1.16-2.91-2.18-.15-3,5.53-2.33,8,2.91,8,3.06,8.44,2.91-6,2.91-6S81.55,247.84,85,244.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,253a3.48,3.48,0,0,0,3.74,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.76,252.58s3.1,1,4.39-.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,257.62s1.16.9,1.93.64a2,2,0,0,0,1-1.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,260.2a3,3,0,0,0,3.61-.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.36,250.9s2.46-1.29,4.39-.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,250.13a4.35,4.35,0,0,1,4.26-.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.76 277.82 93.24 295.03 101.41 294.18 99.68 276.42 90.76 277.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,287.72l-1.26-2.82L100.38,283l.31,1.88,1.1,2.51-4.86-.78-4.23-.16s-.47.94,0,1.1S96.3,289,96.3,289l-4.54.47s-.63,1.25,0,1.57,1.72,3.13,3.45,3.6,8-.94,8-.94,10,18,12.07,19.44,5.8.63,6.75.16,2.68-3,2.5-5.8c-.07-1.25-19-17.25-19-17.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinetransactionsBro);
export default __webpack_public_path__ + "static/media/Online transactions-bro.7a21a9359e44418d2e66bb27dafe025f.svg";
export { ForwardRef as ReactComponent };